import React, { Component } from 'react'
import downloadicon from '../src/images/ebook-img/download-icon.png'
import crypto from 'crypto-js'
import cryptoJs from './crypto'
import firebase from './firebase'
import IntlTelInput from 'react-intl-tel-input';
import 'react-intl-tel-input/dist/main.css';
import FormValidator from './FormValidator';
import FeatLoader from './FeatLoader';
import PopUpmessage from './PopupMessage';
import MessageTemplate from './Constant';
import  { 
  Redirect 
} from 'react-router-dom';
const designationList=[
  {
    label: "Select Designation",
    value: "Select Designation",
  },
  {
    label: "CEO",
    value: "CEO",
  },
  {
    label: "CFO",
    value: "CFO",
  },
  {
    label: "COO",
    value: "COO",
  },
  {
    label: "CTO",
    value: "CTO",
  },
  {
    label: "CMO",
    value: "CMO",
  },
  {
    label: "CLO",
    value: "CLO",
  },
  {
    label: "GM",
    value: "GM",
  },
  {
    label: "DM",
    value: "DM",
  },
  {
    label: "HR",
    value: "HR",
  },
]
export class UserForm extends Component {
  
  
  
    constructor(props) {
      
        super(props);
        

        this.validator = new FormValidator([
          { 
            field: 'name', 
            method: 'isEmpty', 
            validWhen: false, 
            message: 'Enter  name.' 
          },
          { 
            field: 'email', 
            method: 'isEmpty', 
            validWhen: false, 
            message: 'Enter your email address.' 
          },
          { 
            field: 'email',
            method: 'isEmail', 
            validWhen: true, 
            message: 'Enter valid email address.'
          },
          { 
            field: 'phone', 
            method: 'isEmpty', 
            validWhen: false, 
            message: 'Enter a valid phone number.'
          },
          
          { 
            field: 'organization', 
            method: 'isEmpty', 
            validWhen: false, 
            message: 'Enter organization.'
          },
          { 
            field: 'designation', 
            method: 'isEmpty', 
            validWhen: false, 
            message: 'Enter designation.'
          },
          
          
        ]);

        

        this.state = {
          
          name: '',
          organization: '',
          designation: '',
          email:'',
          phone:'',
          recaptcha:'',
          isButtonDisabled:true,
          sendOTP:false,
          otp:'',
          guid:'',
          isValidPhone:false,
          validation: this.validator.valid(),
          IsShowLoader:false,
          IsShowMessagePopup:'',
          PopUpmessage:'',
          type:'success'
        };
        this.create = this.create.bind(this);
        this.handleLoader=this.handleLoader.bind(this);
        this.handlePopupMessage=this.handlePopupMessage.bind(this);
        this.handleOTPCheck=this.handleOTPCheck.bind(this);
        this.ProtectedComponent=this.ProtectedComponent(this);
        this.submitted=false;
        

    }
    

    componentDidMount(){
      
        window.recaptchaVerifier = new firebase.auth.RecaptchaVerifier(
            "recaptcha-container",
            {
              size: "normal",
              callback: response => {
                // reCAPTCHA solved, allow signInWithPhoneNumber.
                // ...
                this.setState({ isButtonDisabled: false });
              },
              "expired-callback": response => {
                // Response expired. Ask user to solve reCAPTCHA again.
                // ...
                this.setState({ isButtonDisabled: true });
                alert("Recaptcha Expire Please try agian");
              }
            }
          );
          window.recaptchaVerifier.render().then(function(widgetId) {
            window.recaptchaWidgetId = widgetId;
          });
        
    }

    

    create(e) {
    
    if(this.state.isButtonDisabled){
      this.handlePopupMessage(true,'Please resolve reCAPTCHA','error');
      return;
    }
    const validation = this.validator.validate(this.state);
    this.setState({ validation });
    this.submitted = true;
    
    if(this.state.name.length > 0 && this.state.name.length < 3){
      this.handlePopupMessage(true,'Name should be minimum 3 characters','error');
      return;
    }
    if(this.state.designation=='Select Designation'){
      this.handlePopupMessage(true,'Please select designation','error');
      return;
    }
    if(this.state.organization.length > 0 && this.state.organization.length < 4){
      this.handlePopupMessage(true,'Organization should be minimum 4 characters','error');
      return;
    }
    

    if(!this.state.isValidPhone){
        this.handlePopupMessage(true,'Enter Valid Phone number','error');
        return;
      }else{
        validation.phone.isInvalid=false;
        validation.phone.message=''
      }

    if (validation.isValid) {
      
        const requestOptions = {
            crossDomain:true,
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                Name: this.state.name,
                Email: this.state.email,
                Company:this.state.organization,
                Designation:this.state.designation,
                Phone:this.state.phone,
                
              })
        };

        console.log(requestOptions);
        // add entity - POST
        e.preventDefault();
        
        this.handleLoader(true);
        // creates entity
        let url=MessageTemplate.API_BASE_URL+'/Admin/SaveIRISEbookDownload'
        
        fetch(url, requestOptions)
        .then(response => response.json())
        .then(response => {
          
          let data=cryptoJs(response);
          // this.setState({IsShowLoader:false});
          if(data.Status){
              this.setState({Phone:data.Response.Phone,
                            Email:data.Response.Email,
                            guid:data.Response.guid
              })
              var appVerifier = window.recaptchaVerifier;
              firebase
                .auth()
                .signInWithPhoneNumber(data.Response.Phone, appVerifier)
                .then(confirmationResult => {
                  this.handleLoader(false);
                  this.setState({ sendOTP: true });
                  window.confirmationResult = confirmationResult;
                  this.handlePopupMessage(true,MessageTemplate.OTPSentMessage,'success');
                })
                .catch(err => {
                  this.handleLoader(false);
                  if(err.code && err.code=='auth/too-many-requests'){
                    this.handlePopupMessage(true,MessageTemplate.MaximumLimitMessage,'error');
                  }else{
                    this.handlePopupMessage(true,MessageTemplate.ErrorMessage,'error');
                  }
                });
              
          }

        })
        .catch(err => {
          this.handleLoader(false);
          this.handlePopupMessage(true,MessageTemplate.ErrorMessage);
        });
      }
      //reaches here if form validates successfully...
      
    }
    
     handleKeyPress = (evt) => {
       //console.log(evt.target.attributes.name.value=='name')

      let specialChar = `~!@#$%^&*()_-+={}[]|\\:;"'<>?,./\`eE`;
      let specialCharExceptE = `~!@#$%^&*()_-+={}[]|\\:;"'<>?,./\``;
      if(evt.target.attributes.name.value=='name'){
        const re = /^[a-zA-Z ]+$/;
        if (!re.test(evt.key)) {
          evt.preventDefault();
          return false
        }
      }
      
      // Reference
      // https://stackoverflow.com/questions/1444477/keycode-and-charcode#:~:text=keyCode%3A%20Returns%20the%20Unicode%20value,other%20type%20of%20keyboard%20event.&text=charCode%3A%20Returns%20the%20Unicode%20value,pressed%20during%20a%20keypress%20event.
      evt = evt || window.event;
      var charCode = evt.charCode || evt.keyCode;
      var charStr = String.fromCharCode(charCode);
      //console.log(charStr);
     
      // alert(charStr + 'charStr' + charCode);
      // if (charStr === "+" || charStr === "-" || charStr === "." || charStr === "e" || charStr === "E") {
        if (specialCharExceptE.split("").indexOf(charStr) > -1) {
          evt.preventDefault();
          return false;
      }
      if(evt.target.value.length > 50 ){
        evt.preventDefault();
        return false;
      }
      // if (dontAllowSpecialChar) {
      //     if (specialCharExceptE.split("").indexOf(charStr) > -1) {
      //         evt.preventDefault();
      //         return false;
      //     }
      // } else if (props.type === "number") {
      //     if (specialChar.split("").indexOf(charStr) > -1) {
      //         evt.preventDefault();
      //         return false;
      //     }
      // }

  }
      
      handleChange(changeObject) {
        this.setState(changeObject)
      }
     

      

      handleOTPCheck (e) {
        let self = this;
          if (this.state.otp) {
            let _email = this.state.Email;
            let _guid = this.state.guid;
            let _Name = this.state.name;
            this.handleLoader(true);
            window.confirmationResult
              .confirm(this.state.otp)
              .then(function (result) {
                // User signed in successfully.

                const requestOptions = {
                  crossDomain: true,
                  method: "POST",
                  headers: { "Content-Type": "application/json" },
                  body: JSON.stringify({
                    Email: _email,
                    guid: _guid,
                    Name : _Name
                  }),
                };
                let url =
                  MessageTemplate.API_BASE_URL +
                  "/Admin/SendIRISEbookDownloadLink";
                fetch(url, requestOptions)
                  .then((response) => response.json())
                  .then((response) => {
                    let data = cryptoJs(response);
                    self.handleLoader(false);
                    
                    if (data.Status) {
                      // self.handlePopupMessage(true,MessageTemplate.LinkSentMessage,'success');
                      self.setState({IsShowMessagePopup:'active',PopUpmessage:MessageTemplate.LinkSentMessage,type:'success'});
                      setTimeout( () => {
                        self.setState({IsShowMessagePopup:'',PopUpmessage:''});
                        window.location.href = MessageTemplate.redirectUrl;
                    }, 10000);
                      // self.setState({ sendOTP: false });
                    }
                  })
                  .catch((err) => {
                    self.handleLoader(false);
                   
                    self.handlePopupMessage(true,MessageTemplate.ErrorMessage,'error');
                    
                  });
                // ...
              })
              .catch(function (error) {
                self.handleLoader(false);
                if(error!=null && error.code=='auth/code-expired"'){
                  self.handlePopupMessage(true,error.message,'error');
                }else if(error.code=='auth/invalid-verification-code'){
                  self.handlePopupMessage(true,MessageTemplate.InvaliOTPMessage,'error');
                }
                else{
                  self.handlePopupMessage(true,MessageTemplate.ErrorMessage,'error');
                }
                
                // User couldn't sign in (bad verification code?)
                // ...
              });
          }
        
      };
    
      handleLoader(value){
        this.setState({IsShowLoader:value});
      }

      handlePopupMessage(flag,value,type){
        this.setState({IsShowMessagePopup:'active',PopUpmessage:value,type:type});
        setTimeout( () => {
          this.setState({IsShowMessagePopup:'',PopUpmessage:''});
      }, 10000);
      }

      
     ProtectedComponent () {
      return <Redirect to='/Index'  />
  }
      
      
    render() {
      let validation = this.submitted ?this.validator.validate(this.state) : this.state.validation  
      
        if(this.state.sendOTP===false){
            return (
              <div className="modal-body">
                <div className="register-form leadform">
                  <div className="enterDeati">IRIS eBook</div>
                  <div className="line" />
                  <div className="form-input">
                    <input
                      type="text"
                      className="input-form"
                      id="name"
                      name="name"
                      placeholder="Name"
                      value={this.state.name}
                      onChange={(e) =>
                        this.handleChange({
                          name: e.target.value,
                          [e.target.name]: e.target.value,
                        })
                      }
                      onKeyPress={this.handleKeyPress}
                      required
                    />
                    {validation.name.isInvalid}
                    {
                      <div
                        className="errortxt Er_Name active"
                        id="Er_Name"
                        value=""
                      >
                        {validation.name.message}
                      </div>
                    }
                  </div>
                  <div className="form-input">
                    <input
                      type="text"
                      className="input-form"
                      id="organization"
                      name="organization"
                      placeholder="Organization"
                      value={this.state.organization}
                      onChange={(e) =>
                        this.handleChange({
                          organization: e.target.value,
                          [e.target.name]: e.target.value,
                        })
                      }
                      onKeyPress={this.handleKeyPress}
                      required
                    />
                    {validation.organization.isInvalid}
                    {
                      <div className="errortxt Er_Company" id="Er_Company">
                        {validation.organization.message}
                      </div>
                    }
                  </div>
                  <div className="form-input">
                    <div className="select-container">
                    
                      <select className="input-form" value={this.state.designation} onChange={(e) => this.handleChange({ designation: e.target.value , [e.target.name]: e.target.value})}>
                      {/* <option className="input-form" value='Select Designation'>{'Select Designation'}</option> */}
                        {designationList.map((option) => (
                          <option value={designationList.value}>{option.label}</option>
                        ))}
                      </select>
                    </div>
                    {/* <input type="text" className="input-form" id="designation" name="designation" placeholder="Designation" value={this.state.designation} onChange={(e) => this.handleChange({ designation: e.target.value , [e.target.name]: e.target.value})} onKeyPress={this.handleKeyPress} required /> */}
                    {/* {(validation.designation.isInvalid)}{
                      <div className="errortxt Er_designation" id="Er_designation">{validation.designation.message}</div>
                    } */}
                  </div>
                  <div className="form-input">
                    <input
                      type="email"
                      id="email"
                      className="input-form"
                      name="email"
                      placeholder="Email"
                      value={this.state.email}
                      onChange={(e) =>
                        this.handleChange({
                          email: e.target.value,
                          [e.target.name]: e.target.value,
                        })
                      }
                      required
                    />
                    {validation.email.isInvalid}
                    {
                      <div className="errortxt Er_Email" id="Er_Email">
                        {validation.email.message}
                      </div>
                    }
                  </div>
                  <div className="form-input">
                    <IntlTelInput
                      preferredCountries={["in"]}
                      css={["intl-tel-input", "form-control"]}
                      utilsScript={"libphonenumber.js"}
                      name="phone"
                      onSelectFlag={(num, country) => {
                        //console.log('onSelectFlag', num, country);
                      }}
                      onPhoneNumberChange={(
                        status,
                        value,
                        countryData,
                        number,
                        id
                      ) => {
                        this.handleChange({
                          phone: number,
                          isValidPhone: status,
                        });
                        // console.log('onPhoneNumberChange number', status);
                      }}
                      onPhoneNumberBlur={(
                        status,
                        value,
                        countryData,
                        number,
                        id
                      ) => {
                        //console.log('onPhoneNumberBlur value', value);
                        //console.log('onPhoneNumberBlur number', number);
                        // console.log('onPhoneNumberBlur number', status);
                      }}
                      format
                      formatOnInit={false}
                      separateDialCode
                    />
                    {validation.phone.isInvalid}
                    {
                      <div className="errortxt Er_Phone" id="Er_Phone">
                        {validation.phone.message}
                      </div>
                    }
                  </div>
                  <div id="recaptcha-container"></div>
                  <div className="form-input">
                    <button
                      className="bol-btn"
                      onClick={(e) => this.create(e)}
                      id="btnSubmit"
                    >
                      Submit{" "}
                      <img className="download-icon" src={downloadicon} />
                    </button>
                    {/* <button className="bol-btn" onClick={(e) => this.create(e)} id="btnSubmit" disabled={this.state.isButtonDisabled} >Submit <img className="download-icon" src={downloadicon} /></button> */}
                  </div>
                </div>
                <FeatLoader IsShowLoader={this.state.IsShowLoader} />
                <PopUpmessage
                  IsShowMessagePopup={this.state.IsShowMessagePopup}
                  PopUpmessage={this.state.PopUpmessage}
                  type={this.state.type}
                />
              </div>
            );
        }else{
          
            return(
              
                <div className="register-form otpSection">
                        <div className="enterDeati">OTP</div>
                        <div className="line" />
                        <div className="form-input">
                            <input type="text" className="input-form" id="otp" name="otp" placeholder="Enter OTP" value={this.state.otp} onChange={(e) => this.handleChange({ otp: e.target.value })} required="required" />
                            <div className="errortxt Er_otp" id="Er_otp" />
                        </div>
                        <div className="form-input">
                            <button className="bol-btn" type="submit" onClick={(e) => this.handleOTPCheck(e)} id="btnSubmitotp">Submit OTP <img className="download-icon" src={downloadicon} /></button>
                        </div>
                        
                        <FeatLoader 
                            IsShowLoader={this.state.IsShowLoader}
                         />
                        <PopUpmessage
                          IsShowMessagePopup={this.state.IsShowMessagePopup}
                          PopUpmessage={this.state.PopUpmessage}
                          type={this.state.type}
                        />
                    </div> 
            )
        }
        
        
        
    }
    
}

export default UserForm

